/* @ngInject */
const listOptions = (
  utils,
  types,
  excelStyles,
) => {
  const self = {}

  self.generateOptions = (_options) => {
    const options = utils.copy(_options)
    options.filename = 'listing'
    options.enableColor = false
    options.enableOwnerSheet = true
    options.firstRow = 4
    options.getBodyCells = self.getBodyCells
    options.style = excelStyles.bodyCell()

    return options
  }

  self.getBodyCells = ({ currentRow, }, wagon) => {
    return [{
      name: 'A' + currentRow,
      ref: 'id',
      value: wagon.id,
      type: types.wagonId,
    }, {
      name: 'B' + currentRow,
      ref: 'idNew',
      value: wagon.idNew,
      type: types.wagonId,
    }, {
      name: 'C' + currentRow,
      ref: 'owner',
      value: wagon.owner,
    }, {
      name: 'D' + currentRow,
      ref: 'type',
      value: wagon.type,
    }, {
      name: 'E' + currentRow,
      ref: 'railway',
      value: wagon.railway,
    }, {
      name: 'F' + currentRow,
      ref: 'ratioPosition',
      value: wagon.ratioPosition,
    }, {
      name: 'G' + currentRow,
      ref: 'arrivalDate',
      value: wagon.arrivalDate,
      type: types.date,
    }, {
      name: 'H' + currentRow,
      ref: 'completeRevisionExcel',
      value: wagon.completeRevisionExcel,
    }, {
      name: 'I' + currentRow,
      ref: 'length',
      value: wagon.length,
      type: types.decimal,
    },]
  }

  return self
}
export default listOptions



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/wagon/listOptions.resource.js